import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCentralKitchen || _vm.isSatellite)?_c('p',{class:("tag fr-text-xs mb-0 " + _vm.position)},[_c(VIcon,{attrs:{"x-small":""}},[_vm._v(_vm._s(_vm.isCentralKitchen ? "$community-fill" : "$restaurant-fill"))]),_vm._v(" "+_vm._s(_vm.isCentralKitchen ? "Cuisine centrale" : "Cantine satellite")+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }